import TVApp from "../pages/tv-app";
import Casting from "../pages/tv-app/entertainment/casting";
import FreeStreaming from "../pages/tv-app/entertainment/free-streaming";
import Music from "../pages/tv-app/entertainment/music";
import MyApps from "../pages/tv-app/entertainment/my-apps";
import WiFi from "../pages/tv-app/entertainment/wifi";
import Alarm from "../pages/tv-app/room/alarm";
import Light from "../pages/tv-app/room/light";
import SleepConcierge from "../pages/tv-app/room/sleep-concierge";
import Temperature from "../pages/tv-app/room/temperature";
import Offers from "../pages/tv-app/my-stay/offers";
import ActivityCalendar from "../pages/tv-app/my-stay/activity/create-activity";
import ActivityList from "../pages/tv-app/my-stay/activity/index";
import Services from "../pages/tv-app/my-stay/services/index";
import ServicesCreate from "../pages/tv-app/my-stay/services/create-service";
import Recommendations from "../pages/tv-app/my-stay/recommendations/index";
import CreateRecommendation from "../pages/tv-app/my-stay/recommendations/create-recommendation";
import MySchedule from "../pages/tv-app/my-stay/my-schedule/index";
import MyScheduleCreate from "../pages/tv-app/my-stay/my-schedule/create-my-schedule";
import Packages from "../pages/tv-app/my-stay/packages/packages";
import CreatePackage from "../pages/tv-app/my-stay/packages/create-package";
import OfferTemplates from "../pages/tv-app/my-stay/offers/templates";
import CreateOfferTemplate from "../pages/tv-app/my-stay/templates/create-offer-template";
import CreateOffer from "../pages/tv-app/my-stay/offers/create-offers";
import OurStory from "../pages/tv-app/home/our-story/current-our-story";
import Staff from "../pages/staff";
import ServicesPage from "../pages/services";

export const routes = [
  {
    path: `${process.env.PUBLIC_URL}/tv-app/*`,
    Component: <TVApp />,
    name: "tv-app",
  },
  {
    path: `${process.env.PUBLIC_URL}/mobile-app`,
    Component: <h1>Comming Soon</h1>,
    name: "mobile-app",
  },
  {
    path: `${process.env.PUBLIC_URL}/master-users`,
    Component: <h1>Comming Soon</h1>,
    name: "master-users",
  },
  {
    path: `${process.env.PUBLIC_URL}/global-setting`,
    Component: <h1>Comming Soon</h1>,
    name: "global-setting",
  },
  {
    path: `${process.env.PUBLIC_URL}/staff`,
    Component: <Staff />,
    name: "staff",
  },
];

export const tvAppRoutes = [
  {
    path: `${process.env.PUBLIC_URL}/room/lights`,
    Component: Light,
  },
  {
    path: `${process.env.PUBLIC_URL}/room/temperature`,
    Component: Temperature,
  },
  {
    path: `${process.env.PUBLIC_URL}/room/sleep`,
    Component: SleepConcierge,
  },
  {
    path: `${process.env.PUBLIC_URL}/room/alarm`,
    Component: Alarm,
  },
  {
    path: `${process.env.PUBLIC_URL}/entertainment/wifi`,
    Component: WiFi,
  },
  {
    path: `${process.env.PUBLIC_URL}/entertainment/casting`,
    Component: Casting,
  },
  {
    path: `${process.env.PUBLIC_URL}/entertainment/livetv`,
    Component: FreeStreaming,
  },
  {
    path: `${process.env.PUBLIC_URL}/entertainment/apps`,
    Component: MyApps,
  },
  {
    path: `${process.env.PUBLIC_URL}/entertainment/music`,
    Component: Music,
  },
  {
    path: `${process.env.PUBLIC_URL}/my-stay/offers-and-packages`,
    Component: Offers,
  },
  {
    path: `${process.env.PUBLIC_URL}/my-stay/activity-calendar`,
    Component: ActivityList,
  },

  {
    path: `${process.env.PUBLIC_URL}/my-stay/activity-calendar/create`,
    Component: ActivityCalendar,
  },
  {
    path: `${process.env.PUBLIC_URL}/my-stay/services`,
    Component: Services,
  },
  {
    path: `${process.env.PUBLIC_URL}/my-stay/services/create`,
    Component: ServicesCreate,
  },
  {
    path: `${process.env.PUBLIC_URL}/my-stay/recommendations`,
    Component: Recommendations,
  },
  {
    path: `${process.env.PUBLIC_URL}/my-stay/recommendations/create`,
    Component: CreateRecommendation,
  },
  {
    path: `${process.env.PUBLIC_URL}/my-stay/my-schedule`,
    Component: MySchedule,
  },
  {
    path: `${process.env.PUBLIC_URL}/my-stay/my-schedule/create`,
    Component: MyScheduleCreate,
  },
  {
    path: `${process.env.PUBLIC_URL}/my-stay/packages`,
    Component: Packages,
  },
  {
    path: `${process.env.PUBLIC_URL}/my-stay/packages/create`,
    Component: CreatePackage,
  },
  {
    path: `${process.env.PUBLIC_URL}/my-stay/offers-and-packages/templates`,
    Component: OfferTemplates,
  },
  {
    path: `${process.env.PUBLIC_URL}/my-stay/offers-and-packages/templates/create`,
    Component: CreateOfferTemplate,
  },
  {
    path: `${process.env.PUBLIC_URL}/my-stay/offers-and-packages/create`,
    Component: CreateOffer,
  },
  {
    path: `${process.env.PUBLIC_URL}/home/home`,
    Component: OurStory,
  },
  {
    path: `${process.env.PUBLIC_URL}/services/essentials`,
    Component: ServicesPage,
  },
  {
    path: `${process.env.PUBLIC_URL}/services/dining`,
    Component: ServicesPage,
  },
  {
    path: `${process.env.PUBLIC_URL}/services/services`,
    Component: ServicesPage,
  }
];
